import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { ShowPDF } from "./CommonUtilities/CommonFunctions/CommonFunction";
import { downloadPDF } from "./CommonUtilities/CommonFileUpload/ViewImage";
import { BsDownload, BsEye } from "react-icons/bs";
import Spinner from 'react-bootstrap/Spinner';
import { config } from "./CommonUtilities/CommonUrl/CommonUrls";

export const documentData = {
  pressNote: [
    { name: "MEGA DSC _ Press Note - EM", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105508922_.pdf" },
    { name: "MEGA DSC _ Press Note - TM", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105545966_.pdf" },
    { name: "Press Note Final", url: "/DSC-PDF/Press-2025/Press Note Final 11.7.25.pdf" },
    { name: "Fake News in Social Media - Clarifications to Candidates", url: "/DSC-PDF/Press-2025/Fake News.pdf" },
    { name: "DSC Press Note (21-8-2025)", url: "/DSC-PDF/Press-2025/PRESS RELEASE (21-8-2025).pdf" },
    { name: "DSC Press Note (22.8.2025) on Merit List", url: "/DSC-PDF/Press-2025/DSC_Press Note 22.8.2025.pdf" },
    { name: "Final Press Release 25.8.2025-1", url: "/DSC-PDF/Press-2025/Final Press Release 25.8.2025-1.pdf" },
    { name: "MEGA DSC-2025 List of Doc for verificationa and Qualificaions", url: "/DSC-PDF/Press-2025/MEGA DSC-2025 List of Doc for verificationa and Qualificaions.pdf" },
    { name: "DSC Press Note 29.8.2025", url: "/DSC-PDF/Press-2025/Press Note.pdf" },
  ],
  gos: [
    { name: "G.O.Ms.77, GAD (Ser.D), Dt:02.08.2023.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105141099_.pdf", },
    { name: "G.O.Ms.No:03, GAD(Ser.D), Dt:17.01.2024.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105069018_.pdf", },
    { name: "G.O.Rt.No:56, School Education (Services-1) Dept., Dated:09.02.2024.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105319843_.pdf", },
    { name: "G.O.Ms.No:11, School Education (Services-1) Dept., Dated:12.02.2024", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105286764_.pdf", },
    { name: "G.O.Ms.No:12, School Education (Services-1) Dept., Dated:12.02.2024", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105296858_.pdf", },
    { name: "G.O.Ms.No:27, School Education (Services-1) Dept., Dated:13.06.2024.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105180295_.pdf", },
    { name: "G.O.Rt.No:256, School Education (Services-1) Dept., Dated:30.06.2024.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105326237_.pdf", },
    { name: "G.O.Ms.No:14, School Education (Services-1) Dept., Dated:15.04.2025.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745104748073_.pdf", },
    { name: "G.O.Ms.No:12, School Education (Services-1) Dept., Dated:17.04.2025.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105169054_.pdf", },
    { name: "G.O.Ms.No.4, Youth, Advancement, Tourism and Culture (Sports), Dated:19.04.2025.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105215758_.pdf", },
    { name: "G.O.Ms.No.7, Social Welfare (CV) Department , dt: 18-04-20205", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105247931_.pdf", },
    { name: "G.O.Ms.No:46, GAD(Ser.D), Dt:19.04.2025.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105090281_.pdf", },
    { name: "G.O.Ms.No:47, GAD(Ser.D), Dt:19.04.2025.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105117199_.pdf", },
    { name: "G.O.Ms.No:15, School Education (Services-1) Dept., Dt:19.04.2025.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105305015_.pdf", },
    { name: "G.O.Ms.No:16, School Education (Services-1) Dept., Dt:19.04.2025.", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105313425_.pdf", },
    { name: "NORMALIZATION", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105418986_.pdf", },
    { name: "ORDINANCE- SC CLASSIFICATION (1)	", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105445190_.pdf", },
    { name: "G O Ms No 17", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745928353836_.pdf", },
    { name: "G O Ms No 18", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745928437416_.pdf", },
    { name: "Amendment School Education", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745934981992_.pdf", },
    { name: "Amendment Societies", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745928724920_.pdf", },
  ],
  syllabus: [
    { name: "MEGA DSC_2025_Suggestive_Syllabus", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105618794_.pdf", },
  ],
  schedule: [
    { name: "AP MEGA DSC schedule", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105586939_.pdf" },
  ],
  faqs: [
    { name: "MEGA DSC FAQ EM", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745104589077_.pdf", },
    { name: "MEGA DSC FAQsTM", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745104669923_.pdf", },
  ],
  manuals: [
    { name: "User Manual Document", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745112162841_.pdf", type: "document" },
    { name: "User Manual Video (English)", url: "https://youtu.be/JQ92XJwpZQ8", type: "video", },
    { name: "User Manual Video (Telugu)", url: "https://youtu.be/eyXIaNtOI6o", type: "video", },
  ],
  school: [
    // { name: "School Education Notification", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200345488_.pdf", },
    { name: "School Education Notification", url: "/DSC-PDF/Notifications/School Edu Notification.pdf" },
    { name: "School Education Bulletin", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200455385_.pdf", },
  ],
  society: [
    // { name: "Residential Schools Notification", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200548788_.pdf", },
    { name: "Residential Schools Notification", url: "/DSC-PDF/Notifications/Socities Notification.pdf" },
    { name: "Residential Schools Bulletin", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200590856_.pdf", },
  ],
  MockTest: [
    { name: "SGT", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M128", type: "video", post: "Mock", },
    { name: "PGT Principal", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M129", type: "video", post: "Mock", },
    { name: "TGT Social", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M130", type: "video", post: "Mock", },
    { name: "TGT Physical science", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M131", type: "video", post: "Mock", },
    { name: "TGT Maths", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M132", type: "video", post: "Mock", },
    { name: "TGT Biological science", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M133", type: "video", post: "Mock", },
    { name: "PGT Biological science", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M134", type: "video", post: "Mock", },
    { name: "PGT Botany", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M135", type: "video", post: "Mock", },
    { name: "PGT Commerce", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M136", type: "video", post: "Mock", },
    { name: "PGT Economics", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M137", type: "video", post: "Mock", },
    { name: "PGT English", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M138", type: "video", post: "Mock", },
    { name: "PGT Maths", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M139", type: "video", post: "Mock", },
    { name: "PGT Physical science", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M140", type: "video", post: "Mock", },
    { name: "PGT Social", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M141", type: "video", post: "Mock", },
    { name: "PGT Telugu", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M142", type: "video", post: "Mock", },
    { name: "PGT Zoology", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M143", type: "video", post: "Mock", },
    { name: "TGT Proficiency Test", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M144", type: "video", post: "Mock", },
    { name: "Proficiency Test Principle", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M145", type: "video", post: "Mock", },
    { name: "Principle", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M146", type: "video", post: "Mock", },
    { name: "Proficiency Test PGT", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M147", type: "video", post: "Mock", },
    { name: "TGT English", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M148", type: "video", post: "Mock", },
    { name: "TGT Hindi", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M149", type: "video", post: "Mock", },
    { name: "TGT Sanskrit", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M150", type: "video", post: "Mock", },
    { name: "TGT Telugu", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M151", type: "video", post: "Mock", },
    { name: "SA Tamil", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M152", type: "video", post: "Mock", },
    { name: "SA Odiya", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M153", type: "video", post: "Mock", },
    { name: "SA Kannada", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M154", type: "video", post: "Mock", },
    { name: "SA Urdu", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M155", type: "video", post: "Mock", },
    { name: "SA Social", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M156", type: "video", post: "Mock", },
    { name: "SA Biological Science", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M157", type: "video", post: "Mock", },
    { name: "SA Physical Science", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M158", type: "video", post: "Mock", },
    { name: "SA Maths", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M159", type: "video", post: "Mock", },
    { name: "SA Sanskrit", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M160", type: "video", post: "Mock", },
    { name: "SA Hindi", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M161", type: "video", post: "Mock", },
    { name: "SA English", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M162", type: "video", post: "Mock", },
    { name: "SA Telugu", url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M163", type: "video", post: "Mock", },
    { name: "PGT Hindi", url: "https://g21.digialm.com/OnlineAssessment/index.html?1950@@M164", type: "video", post: "Mock", },
    { name: "PGT Sanskrit", url: "https://g21.digialm.com/OnlineAssessment/index.html?1950@@M165", type: "video", post: "Mock" },
    { name: "PET PE PD", url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M166", type: "video", post: "Mock", },
  ],

  //----------------TET MockTest Links ----------------//
  TetMockTest: [

    { name: "PAPER_IA_SGT", url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M107", type: "video", post: "Mock", },
    { name: "PAPER_IIB", url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M122", type: "video", post: "Mock", },
    { name: "PAPER_IB", url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M99", type: "video", post: "Mock", },
    { name: "PAPER_IIA_LAN_TELUGU", url: "	https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M104", type: "video", post: "Mock", },
    { name: "PAPER_IIA_LAN_URDU", url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M105", type: "video", post: "Mock", },
    { name: "PAPER IIA LAN HINDI", url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M126", type: "video", post: "Mock", },
    { name: "PAPER_IIA_LAN_KM", url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M101", type: "video", post: "Mock", },
    { name: "PAPER_IIA_LAN_OM", url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M102", type: "video", post: "Mock", },
    { name: "PAPER_IIA_LAN_TAM", url: "	https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M103", type: "video", post: "Mock", },
    { name: "PAPER_IIA_LAN_ENG", url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M168", type: "video", post: "Mock", },
    { name: "PAPER IIA LAN SANSKRIT", url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M127", type: "video", post: "Mock", },
    { name: "PAPER_IIA_MATHS", url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M167", type: "video", post: "Mock", },
    { name: "PAPER_IIA_SOCIAL", url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M108", type: "video", post: "Mock", },
  ],


  // FinalKey: showExamKeys
  // tet_go: [{ name: "APKGBV Memo Recruitment Permission",  url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/KGBV MEMO.pdf" },],
  tet_press_note: [
    // { name: "APKGBV Press Note G.O 36", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/Press note on APTET.pdf" },
  { name: "APKGBV Press Note-2026", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/KGBV PRESS NOTE.pdf" },
  ],
  tet_notification: [{ name: "APKGBV Notification-2026", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/KGBV NOTIFICATION.pdf" },],
  // tet_latestpressnote: [{ name: "APTET Press Note -2025", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/TETPressNote.pdf" },],
  // tet_schedule: [{ name: "APKGBV Tentative Schedule", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/APTET TENTATIVE SCHEDULE.pdf" },
  // { name: "APKGBV Exam Schedule", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/APTET EXAM.pdf" },],
  // tet_syllabus: [
  //   { name: "APKGBV 2025 Syllabus", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/TET  OCTOBER 2025 SYLLABUS BOOK FINAL.pdf" },
  // ],
  tet_bullitin: [{ name: "APKGBV Proceedings filling of Posts", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/KGBV PROCEEDINGS.pdf" },],

  tet_manuals: [
    { name: "User Manual Document", url: process.env.PUBLIC_URL + "/TET-PDF/UserManual/User Manual.pdf", type: "document" },
    { name: "User Manual Video (English)", url: "https://youtu.be/DZbRLOzkeJg", type: "video", },
    // { name: "User Manual Video (Telugu)", url: "https://youtu.be/eyXIaNtOI6o", type: "video", },
  ],
  tet_faq: [{ name: "APKGBV 2026 Faq's", url: process.env.PUBLIC_URL + "/TET-PDF/APTET 2025 FAQS.pdf" },
  { name: "TET Application Instructions", url: process.env.PUBLIC_URL + "/TET-PDF/TET_Application_Instructions.pdf" },
  ],
  // tet_hallticket: [{ name: "APKGBV Hall Tickets Released", url: "ht", }],
  // tet_answerkey: [
  //   {
  //     name: (<> <img src="/img/new2.gif"
  //       style={{ height: "30px" }}
  //       className="img-fluid"
  //       alt="new" />
  //       <span className="text-danger"> APKGBV Preliminary Answer Keys Released </span>
  //     </>
  //     ), url: "data",
  //   },],
  // tet_final_key: { name: "Final Key", clickable: () => { handleGoClose(); renderExams(); }}
  tet_final_key: { name: "Final Key", url: 'renderExams' },


  //   DSC:[
  // {name:"Notification & Information Bulletin (School Education)",url:'school'},
  // {name:"Notification & Information Bulletin (Residential Schools)",url:'society'},
  // {name:"Subjects & Syllabus",url:'syllabus'},
  // {name:"MOCK TEST LINKS",url:'MockTest'},
  // {name:"Final Key",url:'renderExams'},
  // {name:"Post Vacancies (School Education)",url:'/SEPostVacancies'},
  // {name:"Post Vacancies (Residential Education)",url:'/REPostVacancies'},
  // {name:"Press Note",url:'pressNote'},
  // {name:"Government Orders (GOs)",url:'gos'},
  // {name:"Frequently Asked Questions",url:'faqs'},
  // {name:"User Manual",url:'manuals'},
  // {name:"Schedule",url:'schedule',clickable: openDocumentModal("Schedule", "schedule")},
  // {name:"Mega DSC General Merit List-2025",url:'/MeritList1'},
  //   ]
};
const DocumentsModal = ({ show, handleClose, title, data, onItemClick }) => {
  const handleItemClick = (item) => {
    if (item.type === "video" || item.type === "link") {
      window.open(item.url, "_blank");
    } else {
      if (onItemClick) {
        onItemClick(item);
      } else {
        ShowPDF(item.url);
      }
    }
    handleClose();
  };
  const [loading, setLoading] = useState(false);
  const showFinalKeyColumn = Array?.isArray(data) &&
    data.some(item => item?.f_key);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="kgbv-gomodal">
      <Modal.Header closeButton className="kgbv-modalheader">
        <Modal.Title className="kgbv-gomodaltitle">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="kgbv-modalbody">
        <>
          {loading && (
            <div className="fp-container">
              <Spinner animation="border" variant="info" className="fp-loader" />
            </div>
          )}
        </>
        <Table striped hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>{title === "APDSC-2025 MOCK TEST LINKS" && "Post"} Name</th>
              {title === "APTET-2025 Answer Keys" ? (
                <>
                  <th>Initial Key</th>
                  {showFinalKeyColumn && <th>Final Key</th>}
                </>
              ) : (
                <th>Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}.</td>
                  <td>{item.name}</td>
                  {title === "APTET-2025 Answer Keys" ? (
                    <>
                      <th>
                        {" "}
                        <button
                          type="button"
                          className="btn btn-primary ms-2 p-2 pt-1"
                          disabled={loading}
                          onClick={() => {
                            downloadPDF(item.c_key, setLoading);
                          }}
                        >
                          <BsDownload className="me-1" />
                        </button>
                      </th>
                      {showFinalKeyColumn && (
                        <th>
                          {item?.f_key ? (
                            <button
                              type="button"
                              className="btn btn-primary ms-2 p-2 pt-1"
                              onClick={() => downloadPDF(item.f_key, setLoading)}
                            >
                              <BsDownload className="me-1" />
                            </button>
                          ) : (
                            "-"
                          )}
                        </th>
                      )}
                    </>
                  ) : (
                    <td>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleItemClick(item)}
                      >
                        Click Here
                      </Button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};
export default DocumentsModal;
